<template>
  <div>
    <GmapMap
      :center="{lat:-2.548926, lng:118.0148634}"
      :zoom="5"
      map-type-id="terrain"
      style="width: 100%; min-height: 500px">
      <GmapCluster>
        <gmap-marker v-for="(m, index) in markers"
          :position="m.lat ? m: {lat: 0.00000 , lng: 0.0000}"
          :clickable="true" :draggable="true"
          :key="index"
        ></gmap-marker>
      </GmapCluster>
    </GmapMap>
  </div>
</template>

<script>
  import GmapCluster from 'vue2-google-maps/dist/components/cluster' // replace src with dist if you have Babel issues

  export default {
    data () {
      return {
        markers : null,
      }
    },
    props : ['filterUrl'],
    components:{
      GmapCluster,
    },
    mounted () {
      
    },
    watch : {
      filterUrl:{
        handler : 'fetchData'
      }
    },
    methods : {
      fetchData(){
        this.$http.get('/api/h1/customer-location/map?' + this.filterUrl)
        .then((resp)=>{
          var data = resp.data.data;

          for(var i = 0; i < data.length; i++){
            data[i].lat = parseFloat( data[i].lat )
            data[i].lng = parseFloat( data[i].lng )
          }

          this.markers = data;
        })
        .catch((err)=>{
          console.log(err);
        })
      }
    }
  }
</script>

<style scoped></style>